import { IconButton, Tooltip } from "@mui/material"
import MUIIcon from "./MUIIcon"
import { TextContent } from "@cloudscape-design/components"

export default ({text}: {text: string}) => {
    return (
        <Tooltip disableFocusListener title={<div dangerouslySetInnerHTML={{ __html: text }}></div>} placement="bottom">
            <IconButton sx={{marginTop: "-4px"}} >
                <MUIIcon icon="HelpIcon"/>
            </IconButton>
        </Tooltip>
    )
}

// import * as React from 'react';
// import { styled } from '@mui/material/styles';
// import Button from '@mui/material/Button';
// import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
// import Typography from '@mui/material/Typography';

// const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: theme.palette.common.white,
//     color: 'rgba(0, 0, 0, 0.87)',
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//   },
// }));

// const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
//   <Tooltip {...props} arrow classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.arrow}`]: {
//     color: theme.palette.common.black,
//   },
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: theme.palette.common.black,
//   },
// }));

// const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: '#f5f5f9',
//     color: 'rgba(0, 0, 0, 0.87)',
//     maxWidth: 220,
//     fontSize: theme.typography.pxToRem(12),
//     border: '1px solid #dadde9',
//   },
// }));

// export default function CustomizedTooltips() {
//   return (
//     <div>
//       <LightTooltip title="Add">
//         <Button>Light</Button>
//       </LightTooltip>
//       <BootstrapTooltip title="Add">
//         <Button>Bootstrap</Button>
//       </BootstrapTooltip>
//       <HtmlTooltip
//         title={
//           <React.Fragment>
//             <Typography color="inherit">Tooltip with HTML</Typography>
//             <em>{"And here's"}</em> <b>{'some'}</b> <u>{'amazing content'}</u>.{' '}
//             {"It's very engaging. Right?"}
//           </React.Fragment>
//         }
//       >
//         <Button>HTML</Button>
//       </HtmlTooltip>
//     </div>
//   );
// }
